/* src/app/private/components/roll-number/delete-roll-number/delete-roll-number.component.scss */
/*# sourceMappingURL=delete-roll-number.component.css.map */
